module.exports = __webpack_public_path__ + "img/orange.2574dc90.png";